export default class doubleFlickitySlider {
    constructor(innerSlider) {

        if (!innerSlider) return;

		let outerSlideshow = document.getElementById('outer-slideshow')

		if (!outerSlideshow) return;

		let flickity_options = {}
		let flickity_options_2 = {}

		// Get data-flickity from HTML.
		if (innerSlider.getAttribute('data-flickity')) {
			flickity_options = JSON.parse(innerSlider.getAttribute('data-flickity'));
		}

		// Get data-flickity from HTML.
		if (outerSlideshow.getAttribute('data-flickity')) {
			flickity_options_2 = JSON.parse(outerSlideshow.getAttribute('data-flickity'));
		}

		let flkty = new Flickity( innerSlider, flickity_options )
		let outerFlkty = new Flickity( outerSlideshow, flickity_options_2 )


		if (!innerSlider) return;
		doTheFunction();

		function doTheFunction() {
			outerFlkty.select( flkty.selectedIndex )
		}

		flkty.on('change', function () {doTheFunction()})

		window.addEventListener('resize', doTheFunction, false)
	}
}
